<section class="index h-75 d-flex">
  <div class="container container-index">
    <div class="row justify-content-around align-content-center art-group h-75">
      <app-booking-area-item-pack class="col-12 col-md-4 pb-4" *ngFor="let areaItemPack of areaItemPacks" [areaItemPack]="areaItemPack"
        (areaItemSelected)="onAreaItemPackSelected(areaItemPack, $event)"></app-booking-area-item-pack>
      <div *ngIf="areaItemPacks.length === 1" class="col-12 col-md pb-4">
        <app-booking-type [description]="'ab 15 Personen // 12,- €/p.P'" [additionalDescription]="'Für unsere Gemeinnützigen Einrichtungen ab 15 Personen, 90 Minuten Flugzeit'"
          [title]="'Schulen // Vereine' | translate" (click)="onShowGroupEventPage()">
        </app-booking-type>
      </div>
      <!-- <div class="col-12 col-md pb-4 pb-md-0">
        <app-booking-type [description]="'ab 15 Personen // 12,- €/p.P'" [additionalDescription]="'Für unsere Gemeinnützigen Einrichtungen ab 15 Personen, 90 Minuten Flugzeit'"
          [title]="'Gruppen' | translate" (click)="onShowGroupEventPage()">
        </app-booking-type>
      </div> -->
    </div>
  </div>
</section>
<section>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-sm-8 col-md-3">
        <hr>
      </div>
    </div>
    <div *ngIf="getInternalEventInfoLink()" class="row justify-content-center">
        <a style="font-size: 2rem;" href="{{getInternalEventInfoLink()}}" target="_blank">{{ 'Click here for more information about the Event Packs' | translate }}</a>
    </div>
  </div>
</section>
<!-- <section>
  <app-booking-contact-us></app-booking-contact-us>
</section> -->
